var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"divider"},[_vm._v(_vm._s(_vm.label))]),_c('ValidationProvider',{attrs:{"name":_vm.label,"vid":_vm.id}},[_c('input',{attrs:{"type":"hidden","name":_vm.id},domProps:{"value":_vm.label}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }